import { FC, useEffect, useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import Spacing from 'components/Spacing';
import { CheckoutForm } from './CheckoutForm';
import { MainContainer } from 'screens/Main/styled';
import { CheckoutContainer } from 'screens/Checkout/styled';
import { CandidateType } from 'components/Slate/Candidates/Candidates';
import { ContributionRules } from 'components/Slate/ContributionRules';
import { useAuth } from 'hooks/auth';
import { getUserProfile, postUserStripeCustomerSession } from 'store/user/actions';
import { useAppDispatch, useAppSelector } from 'helpers/hooks';
import { getUserData } from 'selectors/user';
import { Elements } from '@stripe/react-stripe-js';
import { Toast } from 'components/Toast';
import { getDefaultTipAmount } from 'screens/Checkout/Form/utils';
import { getSelectedCandidates } from 'helpers/donate';

interface Props {
  candidates: CandidateType[];
  clientId: string;
  donationAmount: number;
  pageId: number;
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_API_KEY as string);

export const StripeCheckout: FC<Props> = ({ candidates, donationAmount, clientId, pageId }) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(getUserData);
  const [donationAmountWithTip, setDonationAmountWithTip] = useState(
    donationAmount + getDefaultTipAmount(donationAmount)
  );
  const [customerSessionClientSecret, setCustomerSessionClientSecret] = useState();

  useAuth(() => {
    dispatch(getUserProfile());
  });

  useEffect(() => {
    if (user?.stripe_customer_id) {
      postUserStripeCustomerSession().then(response => {
        setCustomerSessionClientSecret(response.data.customer_session_client_secret);
      });
    }
  }, [user?.stripe_customer_id]);

  return (
    <MainContainer>
      <Elements
        options={{
          mode: 'payment',
          amount: donationAmountWithTip * 100,
          currency: 'usd',
          customerSessionClientSecret,
        }}
        stripe={stripePromise}
      >
        <CheckoutContainer>
          <Toast /> {/* TODO: remove after real error and success handling complete */}
          <CheckoutForm
            candidates={getSelectedCandidates(candidates)}
            clientId={clientId}
            donationAmount={donationAmount}
            pageId={pageId}
            setDonationAmountWithTip={setDonationAmountWithTip}
            user={user}
          />
          <Spacing $size={70} />
          <ContributionRules />
          <Spacing $size={48.5} />
        </CheckoutContainer>
      </Elements>
    </MainContainer>
  );
};
